import { ElementRef, Inject, Injectable, PLATFORM_ID, Renderer2 } from '@angular/core';
import { configuration } from 'src/configuration';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  isWhiteMenu = false;
  isUserLoggedIn = false;
  userData = {
    name: "",
    nameInitial: "",
    email: "",
    id: ""
  }
  isLoader: any = false
  fromButtonLogin = false;
  
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private metaTagService: Meta,private titleService: Title, private _toastrService: ToastrService) {
    if(this.isBrowser()) {
      let token = this.getTokenValue();
      if (token) {
        this.isUserLoggedIn = true;
        this.userData.id = this.getLocalStorageValue(configuration.LOCAL_STORAGE.USER_ID);
        this.userData.name = this.getLocalStorageValue(configuration.LOCAL_STORAGE.USER_NAME);
        this.userData.email = this.getLocalStorageValue(configuration.LOCAL_STORAGE.USER_EMAIL);
        this.userData.nameInitial = (this.userData.name ? this.userData.name.trim().substring(0,1).toUpperCase() : "");
      }
    }

  }

  includeMainScript() {
    if(this.isBrowser()) {
      var scriptElement = document.createElement('script');
      // Set the type attribute
      scriptElement.type = 'text/javascript';
      // Set the source attribute to the path of your script
      scriptElement.src = '/assets/js/main.js';
      // Append the script element to the body
      document.body.appendChild(scriptElement);
    }
  }

  checkIsUserLoggedIn() {
    return this.isUserLoggedIn;
  }

  public getTokenValue() {
    const localToken = this.getLocalStorageValue(configuration.LOCAL_STORAGE.USER_TOKEN);
    if (localToken != null && localToken && this.getLocalStorageValue(configuration.LOCAL_STORAGE.USER_TOKEN) !== 'undefined') {
      return localToken;
    }
    return false;
  }

  public getLocalStorageValue(key: string, defaultVal: any = '', isObject = false) {
    if(this.isBrowser()) {
      const localVal = localStorage.getItem(key);
      if (localVal != null && localVal !== 'undefined') {
        if (isObject) {
          return JSON.parse(localVal);
        } else {
          return localVal;
        }
      } else {
        return defaultVal;
      }
    } else {
      return defaultVal;
    }
  }

  getImageURL(image: any) {
    return configuration.IMAGE_URL + image;
  }
  private developerBaseUrl = 'https://development-shambhavi.s3.amazonaws.com/direct';

  getDeveloperImageURL(imageName: string): string {
    if (!imageName) {
      return '-';
    }
    return `${this.developerBaseUrl}/${imageName}`;
  }

  formatPriceAED(price:any) {
    // Check if the input is a valid number
    if (isNaN(price)) {
      return "Invalid input";
    }
  
    // Round the price to 2 decimal places
    const roundedPrice = Math.round(parseFloat(price));
  
    // Add thousand separators
    const formattedPrice = roundedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
    // Add AED symbol
    return `${formattedPrice} AED`;
  }

  enablePopoverScript() {
    if(this.isBrowser()) {
      var script = document.createElement('script');
      script.innerHTML = `
      var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
      console.log(popoverTriggerList);
      var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
      });`;
      document.head.appendChild(script);
    }
  }

  isDevUserLoggedIn() {
    return true;
    // if(this.userData && this.userData.id && ["40", "39", "41"].indexOf(this.userData.id) >= 0) {
    //   return true;
    // }
    // return false;
  }

  getIntValue(val) {
    return val*1
  }

  getPageNumbers(count, pageLimit) {
    let totalPages = Math.ceil(count / pageLimit);
    let i = 1;
    const pageNumbers = [];
    if(totalPages > 20) {
      totalPages = 20;
    }
    for (i; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    return pageNumbers;
  }

  capitalizeWords(str) {
    return str
        .split(' ')                  
        .map(word =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ');
  }

  getDateLie(dateString) {
    const date = new Date(dateString);
  
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
  
    return `${month}-${year}`;
  }

  isBrowser() {
    return isPlatformBrowser(this.platformId)
  }

  stripHtmlTags(html: string, maxLength = 160): string {
    const plainText = html.replace(/<\/?[^>]+(>|$)/g, "");
    return plainText.length > maxLength ? plainText.substring(0, maxLength - 3) + '...' : plainText;
  }

  setSEOData(title, meta) {
    let _description = this.stripHtmlTags(meta.description);
    let _title = title + " | Direkt";
    this.titleService.setTitle(_title);
    let _image = environment.CLOUDFRONT_URL + "logo/direkt-white-logo-only.png";
    if(meta.image) {
      _image = meta.image;
    }
    this.metaTagService.addTags([  
      { name: 'description', content: _description },  
      { name: 'keywords', content: _title },  
      { name: 'og:title', content: _title },  
      { name: 'og:description', content: _description },  
      { name: 'og:image', content: _image },  
      { name: 'og:url', content: meta.url },  
      { name: 'twitter:title', content: _title },  
      { name: 'twitter:description', content: _description },  
      { name: 'twitter:image', content: _image },  
      { name: 'keywords', content: _title },  
      { name: 'robots', content: 'index, follow' },  
    ]); 
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  
  generateUrlSlug(inputString) {
    // Convert the input string to lowercase
    let slug = inputString.toLowerCase();
    // Remove special characters
    slug = slug.replace(/[^a-z0-9\s-]/g, '');
    // Replace spaces and multiple hyphens with a single hyphen
    slug = slug.replace(/\s+/g, '-').replace(/-+/g, '-');
    // Trim hyphens from the start and end of the string
    slug = slug.replace(/^-|-$/g, '');
    return slug;
  }
  displaySuccessMessage(data: any = {}) {
    data.msg = data.msg ? data.msg : "Your record is saved!";
    data.header = data.header ? data.header : "Success";
    this._toastrService.success(data.msg, data.header);
  }

  displayErrorMessage(data: any = {}) {
    data.msg = data.msg ? data.msg : "Your record is not saved!";
    data.header = data.header ? data.header : "Error";
    this._toastrService.error(data.msg, data.header);
  }

}
